import type { AppRouter } from '@mysterra/api'
import { hc } from 'hono/client'

import { supabase } from '@/lib/auth/client'

const API_ORIGIN = import.meta.env.VITE_API_ORIGIN as string | undefined

if (!API_ORIGIN) {
  throw new Error('VITE_API_ORIGIN is required')
}

export const api = hc<AppRouter>(API_ORIGIN, {
  async fetch(input, init) {
    const { data } = await supabase.auth.getSession()
    const token = data.session?.access_token
    const headers = new Headers(init?.headers)
    if (token) headers.set('authorization', `Bearer ${token}`)
    return fetch(input, { ...init, headers })
  },
})
